import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";

const TESTIMONIALS = [
  {
    name: "Ritu Sharma",
    area: "Rohini, Delhi",
    text: "After my father's stroke, Sharpin sent a GNM nurse the same evening. Her wound care and patience made his recovery at home possible.",
  },
  {
    name: "Mohd. Arif",
    area: "Noida",
    text: "The japa maid we hired for our newborn was wonderful — she guided my wife through postpartum care like family. Highly recommended.",
  },
  {
    name: "Kavita Mehta",
    area: "Gurugram",
    text: "We needed a 24-hour caretaker for my mother with dementia. The replacement guarantee gave us confidence, and the coordinator checks in weekly.",
  },
];

const Testimonials = () => (
  <section id="stories" className="py-16 md:py-24" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
      <SectionHeading
        number="05 — Families First"
        title="Stories from the homes"
        accent="we care for."
        id="testimonials"
      />

      <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
        {TESTIMONIALS.map((t, i) => (
          <motion.figure
            key={t.name}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="bg-white rounded-3xl border border-slate-200 p-8 hover:border-tealbrand/40 hover:-translate-y-1 hover:shadow-xl transition-all duration-300"
            data-testid={`testimonial-card-${i}`}
          >
            <Quote className="h-8 w-8 text-tealbrand mb-6" />
            <blockquote className="text-sm sm:text-base text-slate-700 leading-relaxed mb-8">
              {t.text}
            </blockquote>
            <figcaption>
              <p className="font-display font-semibold text-navy">{t.name}</p>
              <p className="text-xs uppercase tracking-[0.15em] text-slate-500 font-semibold mt-1">{t.area}</p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
